import { useEffect, useState } from 'react';
import { getAllParties } from '../../controller/PartyDB';
import { IPartyForUser } from '../../PartyClientResponse';
import { Button, Input, Table } from 'antd';
import HomeButton from '../common/HomeButton';

const PartyDetails = () => {
  const [partyKey, setPartyKey] = useState<string>('');
  const [parties, setParty] = useState<IPartyForUser[]>([]);

  useEffect(() => {
    if (partyKey) {
      getAllParties()
        .then((partyResp) => {
          setParty(partyResp);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [partyKey]);

  const party = parties.find((p) => p?.slug?.toLowerCase()?.includes(partyKey.toLowerCase()));

  const dataSource = (party ? Object.values(party?.stage?.participants || {}) : []).filter(
    (p) => p.active
  );

  const columns = [
    {
      title: 'active',
      dataIndex: 'active',
      key: 'active',
    },
    {
      title: 'availableActions',
      dataIndex: 'availableActions',
      key: 'availableActions',
    },
    {
      title: 'currentArea',
      dataIndex: 'currentArea',
      key: 'currentArea',
      // @ts-ignore
      sorter: (a, b) => (a.currentArea < b.currentArea ? 1 : -1),
    },
    {
      title: 'displayName',
      dataIndex: 'displayName',
      key: 'displayName',
      // @ts-ignore
      sorter: (a, b) => (a.displayName < b.displayName ? 1 : -1),
    },
    {
      title: 'photoURL',
      dataIndex: 'photoURL',
      key: 'photoURL',
    },
    {
      title: 'roles',
      dataIndex: 'roles',
      key: 'roles',
    },
    {
      title: 'roles',
      dataIndex: 'roles',
      key: 'roles',
    },
    {
      title: 'tags',
      dataIndex: 'tags',
      key: 'tags',
    },
    {
      title: 'uid',
      dataIndex: 'uid',
      key: 'uid',
      sorter: true,
    },
  ];

  return (
    <div className='onboarding-container'>
      <HomeButton />
      <div className='admin-card'>
        <div className='onboarding-title'>party details: {party?.displayName}</div>
        <div style={{ display: 'flex' }}>
          <Input
            placeholder='filter on party key'
            value={partyKey}
            onChange={(e) => setPartyKey(e.target.value)}
          />
          <Button
            onClick={() => {
              navigator.clipboard.writeText(JSON.stringify(dataSource));
            }}>
            copy
          </Button>
        </div>
        <div className='json-container'>
          {!!party && <Table dataSource={dataSource} columns={columns} pagination={false} />}
        </div>
      </div>
    </div>
  );
};

export default PartyDetails;
